import { t } from 'i18next';
import React from 'react'
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';

const INDICATOR_DEEP = "deep_indicator";
const INDICATOR_PROTECTION = "protection_indicator";
const INDICATOR_APPLICABILITY = "applicability_indicator";
const INDICATOR_RELEVANCE = "relevance_indicator";
const INDICATOR_MITIGATION = "mitigation_indicator";
const INDICATOR_ADAPTATION = "adaptation_indicator";
const INDICATOR_PERFORMANCE = "performance_indicator";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#root');
const L5ModalRegulation = ({ modalIsOpen, closeModal, data, moduleSelected }) => {

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Previsualizar Tecnología"
      >

        <form>
          <div style={{ height: "400px", width: "500px" }}>
            <div className="row">
              <span className="text-center" style={{ fontWeight: 'bold', fontSize: '1.2em', paddingBottom: '0.3em' }}>{t('general.title-modal-regulation')}</span>
              <div className="col-md-12">
                <label className="form-label label-information text-justify">
                  {t("regulation.short.code")}:
                </label>
                <label className="form-label text-justify font-weight-bold">
                  {data.code}
                </label>
              </div>
              <div className="col-md-12">
                <label className="form-label label-information text-justify">
                  {t("regulation.short.name")}:
                </label>
                <label className="form-label text-justify font-weight-bold">
                  {data.name}
                </label>
              </div>
              <div className="col-md-12">
                <label className="form-label label-information text-justify">
                  {t("regulation.short.legal_instrument")}:
                </label>
                <label className="form-label text-justify">
                  {data.legal_instrument}
                </label>
              </div>
            </div>
          </div>

        </form>
        <ReactTooltip id={`${INDICATOR_DEEP}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_DEEP}`
          )}
        </ReactTooltip>
        <ReactTooltip id={`${INDICATOR_PROTECTION}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_PROTECTION}`
          )}
        </ReactTooltip>
        <ReactTooltip id={`${INDICATOR_APPLICABILITY}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_APPLICABILITY}`
          )}
        </ReactTooltip>
        <ReactTooltip id={`${INDICATOR_RELEVANCE}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_RELEVANCE}`
          )}
        </ReactTooltip>
        <ReactTooltip id={`${INDICATOR_MITIGATION}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_MITIGATION}`
          )}
        </ReactTooltip>
        <ReactTooltip id={`${INDICATOR_ADAPTATION}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_ADAPTATION}`
          )}
        </ReactTooltip>
        <ReactTooltip id={`${INDICATOR_PERFORMANCE}_tip_p`}
          place="right" effect="solid" arrowColor="blue" backgroundColor="white" borderColor="blue" border textColor="blue" offset={{ top: 0, right: 100 }}>
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.short.${INDICATOR_PERFORMANCE}`
          )}
        </ReactTooltip>
      </Modal>
    </div>
  )
}

export default L5ModalRegulation